module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModelManagerPage', {
    attrs: {
      "lower-app-name": "emarket",
      "lower-model-name": "categoryl2",
      "version": "1",
      "obj-label": "商品二级分类",
      "parent-field-name": "category_l1_id",
      "parent-id": _vm.parentId
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a031001"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/CategoryL2Manager.vue
// module id = 372
// module chunks = 1